<template>
	<div>
		<a class="btn btn-tiny" :href="rowData.meta.url + '?as=' + rowData.title">
			<i class="icon ion-md-download"></i>
		</a>
	</div>
</template>

<script>
	export default {
		name: 'ColumnFileActions',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		data () {
            return {
            	dropdownOpen: false,
            }
        },
		computed: {
		},
		methods: {
			toggleDropdown() {
                this.dropdownOpen = (this.dropdownOpen) ? false : true;
            },
        }
	}
</script>

<style lang="scss">
	
</style>
